import React from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const E = (props) => {
  const params = useParams();
  const [post, setPost] = React.useState(null);
  // const datas = [
  //   {
  //     id: "1",
  //     name: "Epidemic",
  //   },
  //   {
  //     id: "2",
  //     name: "Earthquake",
  //   },
  //   {
  //     id: "4",
  //     name: "Cyclone",
  //   },
  //   {
  //     id: "5",
  //     name: "Population Movement",
  //   },
  //   {
  //     id: "7",
  //     name: "Civil Unrest",
  //   },
  //   {
  //     id: "8",
  //     name: "Volcanic Eruption",
  //   },
  //   {
  //     id: "12",
  //     name: "Flood",
  //   },
  //   {
  //     id: "13",
  //     name: "Other",
  //   },
  //   {
  //     id: "14",
  //     name: "Cold Wave",
  //   },
  //   {
  //     id: "15",
  //     name: "Fire",
  //   },
  //   {
  //     id: "20",
  //     name: "Drought",
  //   },
  //   {
  //     id: "23",
  //     name: "Storm Surge",
  //   },
  //   {
  //     id: "24",
  //     name: "Landslide",
  //   },
  //   {
  //     id: "27",
  //     name: "Pluvial/Flash Flood",
  //   },
  //   {
  //     id: "57",
  //     name: "Chemical Emergency",
  //   },
  // ];
  React.useEffect(() => {
    axios
      .get("https://goadmin.ifrc.org/api/v2/event/" + params.id)
      .then((response) => {
        setPost(response.data);
      });
  }, [params.id]);

  if (!post) return null;

  return (
    <>
      <section id="services" className="bg-lighter">
        <div className="container pb-0">
          <div className="section-title text-center mb-20">
            <div className="row">
              <div className="col-md-8 col-md-offset-2">
                <h2 className="font-weight-700 text-uppercase">{post.name}</h2>
              </div>
            </div>
          </div>
        </div>
        {post.appeals ? (
          ""
        ) : (
          <section>
            <div class="container p-0 p-sm-15">
              <div class="section-content">
                <div className="row equal-height-inner home-boxes">
                  <div className="col-md-7 col-md-offset-3">
                    <table className="table">
                      <tr>
                        <td>
                          <div className=" mb-0 border-0px">
                            <div className="p-15 pt-20 pb-10">
                              <img src="/images/5.svg" alt="" />
                              <h2 className="font-weight-700 text-uppercase">
                                {/* {
                                  post.appeals[0].num_beneficiaries == null ? "" : post.appeals[0].num_beneficiaries
                                } */}
                              </h2>
                              <h5 className="font-14 font-weight-500 mb-5">
                                People Targeted
                              </h5>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className=" mb-0 border-0px">
                            <div className="p-15 pt-20 pb-10">
                              <img src="/images/3.svg" alt="" />
                              <h2 className="font-weight-700 text-uppercase">
                                {/* {post.appeals[0].amount_requested == null ? "" : post.appeals[0].amount_requested} */}
                              </h2>
                              <h5 className="font-14 font-weight-500 mb-5">
                                Funding Requirements (CHF)
                              </h5>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className=" mb-0 border-0px">
                            <div className="p-15 pt-20 pb-10">
                              <img src="/images/4.svg" alt="" />
                              <h2 className="font-weight-700 text-uppercase">
                                {/* {post.appeals[0].amount_funded  == null ? "" : post.appeals[0].amount_funded} */}
                              </h2>
                              <h5 className="font-14 font-weight-500 mb-5">
                                Funding (CHF)
                              </h5>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </section>
      <section>
        <div className="container pt-20 pb-20">
          <div className="section-content">
            <div className="row">
              <div className="col-md-12">
                <div className="tabbable-panel">
                  <div className="section-content pt-30">
                    <div className="row">
                      <div className="col-xs-12 col-sm-6 col-md-10 col-md-offset-1">
                        <div className="icon-box bg-white left media border-3px  mb-30 p-30 pb-20">
                          <div className="media-body text-center">
                            <h4 className="font-weight-700 text-uppercase">
                              EMERGENCY OVERVIEW
                            </h4>
                            <hr />
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <ul className="list-inline">
                                <li>Disaster Categorization</li>
                                <li>
                                  <h5 className="font-weight-700 text-uppercase">
                                    {post.ifrc_severity_level_display}
                                  </h5>
                                </li>
                              </ul>
                              <ul className="list-inline">
                                <li>Disaster Type</li>
                                <li>
                                  <h5 className="font-weight-700 text-uppercase">
                                    FLOOD
                                  </h5>
                                </li>
                              </ul>
                              <ul className="list-inline">
                                <li>Start Date</li>
                                <li>
                                  <h5 className="font-weight-700 text-uppercase">
                                    {post.disaster_start_date}
                                  </h5>
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-6">
                              <ul className="list-inline">
                                <li>
                                  Government Requests International Assistance
                                </li>
                                <li>
                                  <h5 className="font-weight-700 text-uppercase">
                                    -
                                  </h5>
                                </li>
                              </ul>
                              <ul className="list-inline">
                                <li>NS Requests International Assistance</li>
                                <li>
                                  <h5 className="font-weight-700 text-uppercase">
                                    -
                                  </h5>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container pt-20 pb-20">
          <div className="section-content">
            <div className="row">
              <div className="col-md-12">
                <h4 className="font-weight-700 text-uppercase">
                  EMERGENCY OVERVIEW
                </h4>
                <hr />
                <div
                  dangerouslySetInnerHTML={{
                    __html: post.summary,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default E;
